import { render, staticRenderFns } from "./ModalConfig.vue?vue&type=template&id=2e2d841d&scoped=true"
import script from "./ModalConfig.vue?vue&type=script&lang=js"
export * from "./ModalConfig.vue?vue&type=script&lang=js"
import style0 from "./ModalConfig.vue?vue&type=style&index=0&id=2e2d841d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d841d",
  null
  
)

export default component.exports